import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

// Components
import { Text } from './..'

const EvaluationList = ({ subText, className }) => {
  return (
    <Text
      color='white'
      size='xxs'
      weight='semibold'
      className={classnames(className)}
    >
      {subText}
    </Text>
  )
}

EvaluationList.propTypes = {
  subText: PropTypes.string,
  className: PropTypes.string,
}

export default EvaluationList
